import Pills from '../../../../../pages/vip/features/pills/index';

export default Pills;
